module.exports = __webpack_public_path__ + "img/SelectedFeedbackOkay.4581f269.png";